import './Home.css';

function Home() {
  return (
    <div className="hero">
      <h1>Hi, I'm Emediong </h1>
      <p>A passionate web developer building clean and modern websites.</p>
      <a href="/projects" className="btn">View My Work</a>
    </div>
  );
}

export default Home;